module.exports = __webpack_public_path__ + "media/images/new_home/trash_white-d3b954a4e944815e8a2989b61e181079.png";